import { render, staticRenderFns } from "./DaktelaChatIntegrationForm.vue?vue&type=template&id=7b24f815&"
import script from "./DaktelaChatIntegrationForm.vue?vue&type=script&lang=js&"
export * from "./DaktelaChatIntegrationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports